/**
 * Diagnosis database statistics.
 *
 * Lists the number of published, draft and stub diagnoses.
 */
export class DatabaseStatistics {
  published: number = 0;
  drafts: number = 0;
  stubs: number = 0;

  getTotal(): number {
    return this.published + this.drafts + this.stubs;
  }
}
